import React from 'react';
import fileReaderStream from 'filereader-stream';
import concat from 'concat-stream';
import {MediaEndpoints} from "../../common/ProxyEndpoints";
import AppVariables from "../../common/AppVariables";
import TTLProxy from "../../common/TTLAsyncProxy";
import {Button} from 'reactstrap';
import Confirm from "../Confirm/Confirm";
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";
import PropTypes from 'prop-types';
import MediaHelper from "../../common/MediaHelper";

const DefaultImageUrl = "/img/avatars/user.png";

class EntityImageDisplay extends  React.Component {

    constructor(props) {
        super(props);
        this.selectFile = this.onSelectFile.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.proxy = TTLProxy.getInstance();
        this.state = {
           isBusy: false
        };

    }

    onSelectFile(){
        this._profile_select.click();
    }

    onRemove(){

        const props = this.props;
        const view = props.crudView;
        const proxy = this.proxy;

        //  set busy state for loading
        this.setState({
            isBusy: true
        });

        //
        const source = props.media.sources[0];

        return proxy.processRequest( MediaEndpoints.deleteMedia(props.entityName,props.entityId, source.tag, source.category ) ).then(() => {
            return proxy.processRequest(MediaEndpoints.checkExists(props.entityName, props.entityId));
        }).then(response => {

            const media = response.getPayload();

            if (props.onRemove) {
                props.onRemove(media);
            }

            //
            this.setState({
                isBusy: false
            });

            //
            this._profile_select.files = null;
            this._profile_select.value = null;
            this._confirmRemoveDlg.toggle();

        }).catch(err => {

            //
            HTML.toastWarning(Utils.getResponseError(err));

            this.setState({ isBusy: false });

            this._confirmRemoveDlg.toggle();
        });

    }

    render() {

        const props = this.props;
        const view = props.crudView;
        const proxy = this.proxy;
        const maxFileSize = props.maxFileSize || AppVariables.MaxProfileImageSize;
        const isBusy = view? (view.state.isBusy) : false;
        const hasImage = props.media && props.media.count > 0;

        return <div>

            <Confirm title="Remove Profile Image"
                     onConfirm={this.onRemove}
                     ref={r => this._confirmRemoveDlg = r}
                     body="Do you want to remove profile picture?"
                     confirmText="Remove"
                     isBusy={this.state.isBusy}
                     confirmBtnColor="danger" />

            <input type="file"
                   hidden={true}
                   ref={r => this._profile_select = r}
                   onChange={(evt) => {

                evt.stopPropagation();
                evt.preventDefault();

                const files = evt.target.files;
                if (files.length > 0) {

                    const f = files[0];

                    //  is image
                    if (!f.type.match('image.*')) {
                        return alert('Selected file is not an image!');
                    }

                    if(f.size > maxFileSize){
                        return alert('Image file too big!');
                    }


                    fileReaderStream(f).pipe(concat(async function (content) {

                        content = await MediaHelper.compressImageUploadAsync(content);

                        let endpoint;
                        if (hasImage) {
                            endpoint = MediaEndpoints.updateMedia(props.entityName, props.entityId, props.media.sources[0].tag, f, content);
                        }
                        else {
                            endpoint = MediaEndpoints.createMedia(props.entityName, props.entityId, f, content, props.mediaTag || AppVariables.ProfileImageTag );
                        }

                        if(props.onBeginUpload){
                            if(!props.onBeginUpload(f,content,endpoint)){
                                return;
                            }
                        }

                        //  set busy state for loading
                        if(view)
                            view.setState({
                                isBusy: true,
                                preventDialogClose: true
                            });

                        proxy.processRequest(endpoint).then((response) => {
                            return proxy.processRequest(MediaEndpoints.checkExists(props.entityName, props.entityId));
                        }).then((response) => {

                            let media = response.getPayload();

                            if (props.onCompleteUpload) {

                                //  return true to handle
                                if(props.onCompleteUpload(media)){
                                    return;
                                }
                            }

                            if(view)
                                view.setState({
                                    preventDialogClose: false,
                                    isBusy: false
                                });

                        }).catch((err) => {

                            if(props.onFailUpload){

                                //  return true to handle
                                if(props.onFailUpload(err)){
                                    return;
                                }
                            }

                            if(view)
                                view.setState({
                                    preventDialogClose: false,
                                    isBusy: false
                                });

                        });

                    }))
                }

            }}/>
            <div style={{marginBottom: 4}}>

                <img src={hasImage ? props.media.sources[0].path.static :  ( this.props.defaultSrc || DefaultImageUrl) } alt="Profile image"
                     className="img-responsive img-rounded img-profile" ref="img_profile"
                     style={{marginRight: 'auto', marginLeft: 'auto' , cursor: 'pointer'}}
                     onClick={this.selectFile} />

            </div>

            {hasImage ?
                <div>
                    <Button size={"sm"} color={"danger"} outline={true} onClick={() =>{
                        this._confirmRemoveDlg.show();
                    }} style={{ borderRadius: 8 , marginRight: 4 }}><i className="fa fa-remove"></i> Remove</Button>
                    <Button size={"sm"} color={"primary"} outline={true} onClick={this.selectFile} style={{ borderRadius: 8 }}><i className="fa fa-upload"></i> Change</Button>
                </div> :
                <Button size={"sm"} disabled={isBusy} color={"primary"} outline={true} onClick={this.selectFile} style={{ borderRadius: 8 }}><i className="fa fa-upload"></i> Upload</Button>
            }

        </div>
    }
}

EntityImageDisplay.propTypes = {
    media: PropTypes.object,
    onBeginUpload: PropTypes.func,
    onRemove: PropTypes.func,
    onCompleteUpload: PropTypes.func,
    onFailUpload: PropTypes.func,
    crudView : PropTypes.object,
    entityName: PropTypes.string,
    entityId: PropTypes.number,
    mediaTag: PropTypes.string,
    maxFileSize: PropTypes.number,
    defaultSrc: PropTypes.string
};

export default EntityImageDisplay;


// WEBPACK FOOTER //
// ./src/components/EntityImageDisplay/EntityImageDisplay.js